module.exports = __webpack_public_path__ + "static/media/left hip pain.f8f769b4.png";